import '@fortawesome/fontawesome-free/css/all.css';
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { Ripple } from 'vuetify/lib/directives';
import get from 'lodash/get';
import uk from 'vuetify/es5/locale/uk';
import ru from 'vuetify/es5/locale/ru';

Vue.use(Vuetify, {
  directives: {
    Ripple
  }
});

export interface IAppThemeColors {
  primary: string;
  secondary: string;
  accent: string;
  error: string;
  info: string;
  success: string;
  warning: string;

  'app-colors-background': string,
  'app-colors-background-light': string;
  'app-colors-border-light': string;
  'app-colors-icon-default': string;
  'app-colors-icon-inactive': string;
  'app-colors-link': string;
  'app-colors-text': string;
  'telegram-color': string;
  'viber-color': string;
  'whatsapp-color': string;
  'skype-color': string;
}

const theme = {
  primary: '#37C47E',
  secondary: '#C1CCD4',
  accent: '#2196F3',
  error: '#FF7773',
  info: '#EAF9F2',
  success: '#37C47E',
  warning: '#FF9848',

  'app-colors-background': '#F2F3F7',
  'app-colors-background-light': '#FFFFFF',
  'app-colors-border-light': '#F0F3F4',
  'app-colors-icon-default': '#969699',
  'app-colors-icon-inactive': '#C2C2C2',
  'app-colors-link': '#1976d2',
  'app-colors-text': '#4E4E4E',
  'telegram-color': '#47B4EF',
  'viber-color': '#665CAC',
  'whatsapp-color': '#25D366',
  'skype-color': '#009EDC'
};

export function initVuetify(appSettings: any) {
  let lightTheme = theme;
  let darkTheme = theme;
  if (appSettings && 'systemName' in appSettings && appSettings.systemName !== 'askod_online') {
    lightTheme = get(appSettings, `themes.${appSettings.systemName}.light`, theme);
    darkTheme = get(appSettings, `themes.${appSettings.systemName}.dark`, theme);
  }

  return new Vuetify({
    iconfont: 'fa',
    icons: {
      iconfont: 'fa',
      values: {
        clear: 'fa-times'
      }
    },
    theme: {
      options: {
        customProperties: true
      },
      themes: {
        light: lightTheme,
        dark: darkTheme
      }
    },
    lang: {
      locales: { uk, ru }
    }
  });
}
